import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ComponentList from "./ComponentList.vue";
import ComponentSummary from "./ComponentSummary.vue";
import ComponentFiles from "./ComponentFiles.vue";
import ComponentServicesTabMain from "./ComponentServicesTabMain.vue";
import ComponentNettings from "./ComponentNettings.vue";
import ComponentServicesToPay from "./ComponentServicesToPay.vue";
import { useEUAccountsStore } from "@/store_v3/EUAccountsStore";
import { storeToRefs } from "pinia";
import router from '@/router';
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgTrash from "@/assets/icons/trash.svg";
import BaseTextarea from "@/components-UI/BaseTextarea.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentTabMain',
  setup(__props) {

const EUAccountsStore = useEUAccountsStore();
const {
    form,
    isMainFormFilled,
} = storeToRefs(EUAccountsStore);

const isSingle = computed(() => router.currentRoute.params.id !== 'create');

return { __sfc: true,EUAccountsStore, form, isMainFormFilled, isSingle, ComponentList, ComponentSummary, ComponentFiles, ComponentServicesTabMain, ComponentNettings, ComponentServicesToPay, BaseButton, SvgTrash, BaseTextarea, BaseEditableCard }
}

})